import {
  locationIdFormat,
  productIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const getBinsForProduct = {
  name: "getBinsForProduct" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    productId: productIdFormat.schema,
    includeStorage: z.boolean().nullish(),
    includeReceiving: z.boolean().nullish(),
    useTransferTypeFilter: z.boolean().nullish(),
    includeUncounted: z.boolean().nullish(),
  }),
  output: z.object({
    bins: z.array(
      z.object({
        storageLocationId: storageLocationIdFormat.schema,
        binName: z.string(),
        availableQuantity: z.number(),
        lastCountedAt: z.date().nullable().optional(),
      }),
    ),
    defaultStorageLocationId: storageLocationIdFormat.schema
      .nullable()
      .optional(),
  }),
};
